function versionForDisplay(): string {
  if (typeof window === "undefined") {
    return "development"
  }
  const v = window.APP_VERSION
  if (v != null && v !== "") {
    return String(v)
  }
  return "development"
}

type FooterProps = {
  /** Extra bottom padding so footer clears a fixed MainTabNav. */
  clearFixedTabNav?: boolean
}

export function Footer({ clearFixedTabNav = false }: FooterProps) {
  const year = new Date().getFullYear()
  const version = versionForDisplay()

  const className = [
    "mt-auto w-full shrink-0 border-t border-[var(--color-divider)] pt-6 text-center",
    clearFixedTabNav
      ? "pb-[calc(3.5rem+env(safe-area-inset-bottom,0px))]"
      : "",
  ]
    .filter(Boolean)
    .join(" ")

  return (
    <footer role="contentinfo" data-testid="page-footer" className={className}>
      <p className="text-sm text-[var(--color-text-secondary)]">
        © {year} Doggy Dynamo ({version})
      </p>
      <p className="mt-2 text-sm text-[var(--color-text-secondary)]">
        <a href="/privacy-policy" className="underline">
          Privacy Policy
        </a>
        {" · "}
        <a href="/terms" className="underline">
          Terms of Service
        </a>
      </p>
    </footer>
  )
}
